import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'classnames';

import * as styles from './styles.css';
import { ReadMoreLink } from '../../../../components';

export const AddLabelWithoutProfilingContainerVerboseContent: React.FC = () => {
  const isMobile = useDeviceType() === 'phone';

  return (
    <div className={cn(styles['container'], isMobile && styles['container-mobile'])}>
      <div>Значок покажет, что с вашим объектом можно быстро и безопасно провести сделку.</div>
      <div>
        Вы можете добавить значок, если:
        <ul className={styles['list']}>
          <li>объект не в залоге;</li>
          <li>cобственники — граждане РФ;</li>
          <li>при покупке не использовался материнский капитал.</li>
        </ul>
      </div>
      {isMobile && (
        <div className={styles['read-more']}>
          <ReadMoreLink inline theme="not-filled" bold={false} />
        </div>
      )}
    </div>
  );
};
